import {
  BatteryCharging,
  Cross,
  Droplets,
  FileText,
  Flashlight,
  type LucideIcon,
  Package,
  Pill,
  Radio,
  Shirt,
  Sparkles,
  Tent,
  UtensilsCrossed,
  Wallet,
  Wrench,
} from 'lucide-react';
import { msg } from '@/shared/i18n/msg';
import type { Category } from './category';

export const CATEGORY_LABELS: Readonly<
  Record<Category, { readonly label: string; readonly icon: LucideIcon }>
> = {
  water: { label: msg('Water'), icon: Droplets },
  food: { label: msg('Food'), icon: UtensilsCrossed },
  medication: { label: msg('Medication'), icon: Pill },
  first_aid: { label: msg('First aid'), icon: Cross },
  hygiene: { label: msg('Hygiene'), icon: Sparkles },
  energy: { label: msg('Power and batteries'), icon: BatteryCharging },
  light: { label: msg('Lighting'), icon: Flashlight },
  communication: { label: msg('Communication'), icon: Radio },
  tools: { label: msg('Tools'), icon: Wrench },
  shelter: { label: msg('Shelter and warmth'), icon: Tent },
  clothing: { label: msg('Clothing'), icon: Shirt },
  documents: { label: msg('Documentation'), icon: FileText },
  money: { label: msg('Money'), icon: Wallet },
  other: { label: msg('Other'), icon: Package },
};
